import { ContactName, RewriteUserContactByNameErrorResponse, RewriteUserContactsErrorResponse, RewriteUserContactsInput } from '@uplift/api';
import { AxiosError } from 'axios';

export const getRewriteUserContactsInputFromFormValues = (values: Partial<Record<ContactName, string>>): RewriteUserContactsInput => {
  const phones: RewriteUserContactsInput['phones'] = [
    {
      name: ContactName.mobile,
      number: values[ContactName.mobile]
    },
    {
      name: ContactName.work,
      number: values[ContactName.work],
    },
    {
      name: ContactName.home,
      number: values[ContactName.home].trim() !== '(   )    -' ? values[ContactName.home] : '',
    }
  ].filter(x => !!x.number).reduce((r, v) => ({ ...r, [v.name]: v.number }), {});

  return { phones };
};

export const getFormErrorsFromRewriteUserContactsErrorResponse = (error: AxiosError<RewriteUserContactsErrorResponse | undefined>) => {
  const phones = error.response?.data?.code === 'validation-error' && error.response.data?.fields?.phones;

  if (phones) {
    const errorObj: Partial<Record<ContactName, string>> = {};

    for (const [ key, errorMessage ] of Object.entries(phones)) {
      errorObj[key] = errorMessage;
    }

    return  errorObj;
  }

  return null;
};

export const getFormErrorsFromRewriteUserContactByNameResponse = (
  error: AxiosError<RewriteUserContactByNameErrorResponse | undefined>,
  contactName: ContactName
) => {
  const number = error.response?.data?.code === 'validation-error' && error.response?.data?.fields?.number;

  if (number) {
    const errorObj: Partial<Record<ContactName, string>> = {
      [contactName]: number[0]
    };

    return errorObj;
  }

  return null;
};
